import { JobEnqueueResponse, ListRecordsResponse, SingleRecordResponse } from "@services/api/api.service";
import ORM, { BaseModel } from "./orm";
import BackgroundService from "@services/bg.service";


export interface TemplateGroupStep {
    name: string
    description: string;
    action_title: string;
    action_description: string;
    finalizing_message: string;
    status: string;
    model_id?: string;
}

export interface TemplateOutputModel {
    model_id: string
    class_name: string;
}

export interface TemplateGroup extends BaseModel {
    name: string;
    template_id: string;
    template_version: string;
    applied_at: Date;
    status: string;
    output_models: TemplateOutputModel[];
    steps?: TemplateGroupStep[];
    active_step_idx?: number;
    current_check_job_id?: string;
}


export class _TemplateGroupORM extends ORM<TemplateGroup>{
    public async checkForReady(templateGroupId: string) {
        const result = await this.apiService.request('POST', `/${this.endpoint}/${templateGroupId}/check-for-ready`) as SingleRecordResponse<TemplateGroup>;
        return result.record;
    }

    public async batchAutoEntities(options: any) {
        const initResult = await this.apiService.request('POST', `/${this.endpoint}/batch-auto-entities`, options) as JobEnqueueResponse;
        const jobResults = await BackgroundService.getInstance().waitForJob(initResult.job_id);
        return jobResults;
    }

};

const TemplateGroupORM = new _TemplateGroupORM('templategroups');
export default TemplateGroupORM;


